import { PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";

import {
  fetchBoltOnSearch,
  fetchAccountBoltOns,
  setAccountBoltOn,
  setAccountBoltOnStartDate,
} from "../actions";
import { boltOnsMap } from "../selectors/boltOns";
import { KEEP_CURRENT_ALB } from "../constants";

type NetworkId = 1 | 2;
type BoltOnType = keyof typeof boltOnsMap;

interface SelectedBoltOns {
  [key: number]: {
    [key in BoltOnType]?: string;
  };
}

export const boltOnsExtraReducers = (builder: any) => {
  builder
    .addCase(fetchBoltOnSearch.pending, (state: any) => {
      state.boltOnSearch.fetching = true;
    })

    .addCase(
      fetchBoltOnSearch.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        state.boltOnSearch.fetching = false;
        state.boltOnSearch.response = action.payload;
      }
    )
    .addCase(fetchAccountBoltOns.pending, (state: any) => {
      state.accountBoltOns.fetching = true;
    })
    .addCase(fetchAccountBoltOns.fulfilled, (state: any, action: any) => {
      // As well as storing the response about existing account bolt-ons
      // we store selection defaults to keep any existing bolt-ons per category
      // Categories have to be mapped, hence the complexity
      let selectionUpdate: SelectedBoltOns = {
        1: {},
        2: {},
      };
      const result = _.get(action.payload, "data.result");
      try {
        if (result) {
          for (let selectionType in boltOnsMap) {
            const typedSelectionType = selectionType as BoltOnType;
            boltOnsMap[typedSelectionType].forEach((existingType: string) => {
              if (result[existingType]) {
                // The result can have differing keys :-(
                Object.keys(result[existingType]).forEach((network) => {
                  const r = result[existingType][network];
                  if (r) {
                    selectionUpdate[r.network.id][typedSelectionType] =
                      KEEP_CURRENT_ALB;
                  }
                });
              }
            });
          }
        }
      } catch (error) {
        // Note a bad response shape kills the reducer here, hence the catch.
        console.error(
          "Error mapping account bolt-ons (RECEIVE_ACCOUNT_BOLT_ONS)",
          error
        );
      }
      state.accountBoltOns.fetching = false;
      state.accountBoltOns.response = action.payload;

      // Merge selectionUpdate into state
      Object.keys(selectionUpdate).forEach((key) => {
        const numericKey = parseInt(key, 10) as NetworkId;
        state.selectedBoltOns[numericKey] = {
          ...state.selectedBoltOns[numericKey],
          ...selectionUpdate[numericKey],
        };
      });
    })
    .addCase(setAccountBoltOn, (state: any, action: any) => {
      const { serviceProviderId, boltOnType, value } = action.payload;

      if (!state.selectedBoltOns[serviceProviderId]) {
        state.selectedBoltOns[serviceProviderId] = {};
      }

      state.selectedBoltOns[serviceProviderId][boltOnType] = value;
    })
    .addCase(setAccountBoltOnStartDate, (state: any, action: any) => {
      const { date } = action.payload;

      state.boltOnStartDate = date;
    });
};
